import "./Services.css";
import Button from "../button/Button";
import { Link, useNavigate } from "react-router-dom";
const Services = () => {

    
  return (
    <div id="service-mobile">
      <div className="section">
      <div className="container">
        <div className="sContainer">
        <div className="serviceContent">
          
           <h2>Your Next Project Deserves Our Expertise – Connect with us today !!!</h2>
          <p>
            You’ve found them. With deep industry expertise and a passion for
            immersive tech, we offer the <strong>best Mobile App development services</strong> designed
            to elevate your brand experience through custom-built solutions.
          </p>
          <div><Link to='/contact_us' className="link"><Button  arrowColor="purple" text="Let's Talk"/></Link></div>
        </div>
      </div>
      </div>
      </div>
    </div>
  );
};

export default Services;
